import client from './client';
import qs from 'qs';

const monitorUrl = '/api/v1/eqp/monitor';

// ============================= 장비 모니터링 보드 =============================

export const getMonitorBoard = () => client.get(`${monitorUrl}/board`);

export const getMonitorTimeline = (params) =>
  client.get(`${monitorUrl}/timeline?${qs.stringify(params)}`);

export const getMonitorEvents = (params) =>
  client.get(`${monitorUrl}/events?${qs.stringify(params)}`);

export const getMonitorMetrics = (params) =>
  client.get(`${monitorUrl}/metrics?${qs.stringify(params)}`);

// 응답 봉투 키가 화면마다 data/info 로 다르게 내려와서 셋 다 받아 본다. 래핑이 없으면(타임라인처럼
// {eqpUuid, intervals, summary} 가 바로 오는 경우) 응답 바디 자체를 돌려준다.
export const extractPayload = (res) => {
  const d = res?.data;
  if (!d || typeof d !== 'object') return d ?? null;
  if (d.data !== undefined) return d.data;
  if (d.info !== undefined) return d.info;
  return d;
};

// list 가 어디에 있든(배열 자체 / {list:[]} / data.list / info.list) 찾아서 배열로 돌려준다
export const extractList = (res) => {
  const payload = extractPayload(res);
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.list)) return payload.list;
  return [];
};

// 이벤트 목록처럼 total 건수가 같이 오는 응답용
export const extractTotal = (res) => {
  const payload = extractPayload(res);
  return Number(payload?.total) || 0;
};
